<template>
  <section class="panel panel-default mb-0">
    <div class="panel-heading flex justify-between align-center">
      <div>Total Responses: {{ totalQuestionResponseCount }}</div>
      <button @click="showViewModeModal" class="btn btn-primary">View</button>
    </div>
    <div class="panel-body">
      <div class="flex flex-column">
        <h3 class="m-0">{{ question.uniqueKey.split(':')[0] }}</h3>
        <div class="flex chart-container">
          <template v-if="question.FK_questionTypeKey !== 3">
            <div ref="responseChart" class="response-chart" />
            <div class="response-stats ml-20">
              <template v-for="({ answerKey, answerToSkill }, i) in answerList">
                <response-legend
                  class="mb-5"
                  :key="`answer-${answerKey}`"
                  :color="colors[i]"
                  :label="chartData[i][0]"
                  :percentage="chartData[i][1]"
                  :linked-skills="answerToSkill"
                />
              </template>
            </div>
          </template>
          <template v-else>
            <p class="bg-info p-30 mt-15 written-response-block">
              This email requires a written response, and is manually graded by the administrator.
            </p>
          </template>
        </div>
      </div>
    </div>
    <view-mode-modal :question="question" />
  </section>
</template>

<script>
  import ViewModeModal from './ViewModeModal';
  import ResponseLegend from './ResponseLegend';
  import { getChartColors } from '@authoringPlatform/../store/modules/editMode/helpers';
  import { mapGetters } from 'vuex';
  export default {
    props: ['question', 'itemLevelData'],

    components: {
      ViewModeModal,
      ResponseLegend,
    },

    data() {
      return {
        target: null,
        colors: getChartColors(),
      };
    },

    mounted() {
      if (this.totalQuestionResponseCount > 0) {
        this.buildChart();
      }
    },

    beforeDestroy() {
      if (this.target) this.target.destroy();
    },

    methods: {
      buildChart() {
        const chartOptions = {
          credits: {
            enabled: false,
          },
          chart: {
            type: 'pie',
            margin: [0, 0, 0, 0],
          },
          title: {
            text: null,
          },
          yAxis: {
            title: {
              text: 'Percentage (%)',
            },
          },
          tooltip: {
            formatter: function () {
              return '<strong>' + this.point.name + '</strong>: ' + this.y + ' %';
            },
          },
          series: [
            {
              name: 'Responses',
              data: this.chartData,
              size: '100%',
              innerSize: '40%',
              dataLabels: {
                enabled: false,
              },
              colors: getChartColors(),
            },
          ],
        };

        this.target = new Highcharts.chart(this.$refs.responseChart, chartOptions);
      },
      showViewModeModal() {
        $('#view-mode-modal').modal('show');
      },
    },

    computed: {
      ...mapGetters('editMode/version', ['getTotalUsersCount']),
      totalQuestionResponseCount() {
        return this.answerList.reduce((total, { answerKey }) => {
          const answerResponseCount =
            answerKey in this.itemLevelData ? this.itemLevelData[answerKey].studentCount : 0;
          return total + answerResponseCount;
        }, 0);
      },

      answerList() {
        return Object.values(this.question.answers);
      },
      chartData() {
        return this.answerList.map(({ answerKey }, i) => [
          `Response ${i + 1}`,
          answerKey in this.itemLevelData
            ? Math.round(
                (this.itemLevelData[answerKey].studentCount / this.totalQuestionResponseCount) *
                  1000
              ) / 10
            : 0,
        ]);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .response-chart {
    width: 30%;
    min-width: 250px;
    height: 250px;
  }

  .response-stats {
    width: 70%;
    overflow-y: auto;
  }

  .chart-container {
    height: 275px;
  }

  .written-response-block {
    height: fit-content;
    width: 100%;
    text-align: center;
  }
</style>
